import React from 'react';
import Calendar from './Calendar';
import AnalogClock from './AnalogClock';

import './stylesheets/default/DateTimeCard.css';
import './stylesheets/flat/DateTimeCardFlat.css';
import './stylesheets/neumorphism/DateTimeCardNeumorphism.css';
import './stylesheets/neobrutalism/DateTimeCardNeobrutalism.css';
import './stylesheets/glassmorphism/DateTimeCardGlassmorphism.css';



function DateTimeCard({style}){
      

    return(
        <div className={`date-time-container-${style}`}>
            <h1 className={`title-${style}`}>Current Date and Time</h1>
            <div className={`container-${style}`}>
                <div className={`left-panel-${style}`}>
                    <AnalogClock style={style}/>
                </div>
                <div className={`right-panel-${style}`}>
                    <Calendar style={style}/>
                </div>
            </div>
        </div>
        
    )
}

export default DateTimeCard